import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { FrtPackageTypesEntity } from 'src/app/shared/common-components/common-structure';

@Injectable({
  providedIn: 'root'
})
export class FrtPackageTypesService extends DataService {

  baseUri = this.apiUri + '/frtpackagetypes/';
  constructor(http: HttpClient) {
    super(http);
  }

  getPackageTypeDetails(packageTypeId: number): Observable<FrtPackageTypesEntity[]> {
    this.setUri(this.baseUri + packageTypeId + '/frtpackagetypesid');
    return this.get().pipe(catchError(this.handleError));
  }

  getAllPackageTypes(packageTypeId: number): Observable<FrtPackageTypesEntity[]> {
    this.setUri(this.baseUri);
    return this.get().pipe(catchError(this.handleError));
  }

}
